// Used for dealing with dates stored in Redux on hydration.
import dayjs from "dayjs"

const replacer = (key, value) =>
  value instanceof dayjs ? value.toISOString() : value

const reviver = (key, value) =>
  typeof value === "string" &&
  value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)
    ? dayjs(value)
    : value

export const encode = (toDeshydrate) => JSON.stringify(toDeshydrate, replacer)

export const decode = (toRehydrate) => JSON.parse(toRehydrate, reviver)
